export const TEXTFIELD_VARIANTS = {
  DEFAULT: "default",
  LARGE: "large"
};
